import { Location, Optional } from '@rygen/rygen-ui/model';

import { RoutePlanType } from '../RoutePlanType';
import { ValidShipOrder } from '../ValidShipOrder';

export type ScaffoldRoutePlanPayload =
  | {
      routePlanType: RoutePlanType.CONSOLIDATE;
      shipOrderIds: number[];
    }
  | {
      routePlanType:
        | RoutePlanType.POOL_CONSOLIDATE
        | RoutePlanType.POOL_DISTRIBUTION
        | RoutePlanType.CROSS_DOCK;
      shipOrderIds: number[];
      crossdock: { locationId: number };
    }
  | {
      routePlanType: RoutePlanType.ZONE_SKIPPING;
      shipOrderIds: number[];
      crossdocks: Array<{ locationId: number }>;
    };

const generateCrossdockMember = (
  location?: Location,
): { locationId: number } => {
  if (!location) {
    return { locationId: -1 };
  }

  if (!location.id) {
    throw new Error('crossdock location must have an id');
  }

  return { locationId: location.id };
};

export function generateScaffoldPayload(
  routePlanType: undefined,
  shipOrders?: ValidShipOrder[],
  crossdocks?: Location[],
): Optional<ScaffoldRoutePlanPayload>;
export function generateScaffoldPayload(
  routePlanType: RoutePlanType,
  shipOrders?: ValidShipOrder[],
  crossdocks?: Location[],
): ScaffoldRoutePlanPayload;
export function generateScaffoldPayload(
  routePlanType?: RoutePlanType,
  shipOrders?: ValidShipOrder[],
  crossdocks?: Location[],
): Optional<ScaffoldRoutePlanPayload>;

export function generateScaffoldPayload(
  routePlanType?: RoutePlanType,
  shipOrders: ValidShipOrder[] = [],
  crossdocks: Location[] = [],
): Optional<ScaffoldRoutePlanPayload> {
  const shipOrderIds = shipOrders.map((so) => so.id);

  if (!routePlanType) {
    return undefined;
  } else if (routePlanType === RoutePlanType.CONSOLIDATE) {
    return {
      routePlanType: RoutePlanType.CONSOLIDATE,
      shipOrderIds,
    };
  } else if (
    routePlanType === RoutePlanType.POOL_CONSOLIDATE ||
    routePlanType === RoutePlanType.POOL_DISTRIBUTION ||
    routePlanType === RoutePlanType.CROSS_DOCK
  ) {
    const crossdock = generateCrossdockMember(crossdocks[0]);

    return {
      routePlanType,
      shipOrderIds,
      crossdock,
    };
  } else if (routePlanType === RoutePlanType.ZONE_SKIPPING) {
    const firstCrossdock = generateCrossdockMember(crossdocks[0]);
    const secondCrossdock = generateCrossdockMember(crossdocks[1]);

    return {
      routePlanType,
      shipOrderIds,
      crossdocks: [firstCrossdock, secondCrossdock],
    };
  } else {
    throw new Error(
      `The guards above are exhaustive, so this error should be unreachable but
      typescript demands we have a final clause to satisfy the functions return
      type`,
    );
  }
}
